import React from 'react'
import { PaymentMethod } from '@modmd/data'
import Label, { IndicatorColor } from 'components/Label'

interface StatusLabelModel {
  indicator: keyof typeof IndicatorColor
  label: string
}

interface Props {
  paymentStatus: PaymentMethod | null
  invoiceDocNumber?: string | null
  isInvoiceDocNumber?: boolean
}

const getStatusLabelProps = (
  paymentStatus: PaymentMethod | null,
  invoiceDocNumber?: string | null
): StatusLabelModel => {
  if (paymentStatus === PaymentMethod.Insurance) {
    return {
      indicator: 'zimaBlue',
      label: 'Insurance',
    }
  }
  if (paymentStatus === PaymentMethod.CreditCard) {
    return {
      indicator: 'grayDark',
      label: 'Credit Card',
    }
  }
  if (paymentStatus === PaymentMethod.Invoice && invoiceDocNumber) {
    return {
      indicator: 'lightGreen',
      label: `Invoiced NO: ${invoiceDocNumber}`,
    }
  }

  return {
    indicator: 'blue',
    label: 'Invoicing',
  }
}

export const EventPaymentLabel: React.VFC<Props> = ({ paymentStatus, invoiceDocNumber }) => {
  const statusLabel = getStatusLabelProps(paymentStatus, invoiceDocNumber)
  return (
    <Label size="l" indicator={statusLabel.indicator}>
      {statusLabel.label}
    </Label>
  )
}
